import { useMutation, useQueryClient } from '@tanstack/react-query';
import { lineItemService } from '@services/lineItem';
import { toast } from 'react-toastify';
import { PROJECT_BUDGET_SUMMARY_QUERY_KEY } from './useGetProjectBudgetSummary';
import { AVAILABLE_BUDGET_ITEMS_QUERY_KEY } from '@hooks/api/invoice';
import { useTranslation } from '@hooks/useTranslation';

export const useDeleteLineItem = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (lineItemId: string) => lineItemService.deleteLineItem(lineItemId),
    onSuccess: () => {
      toast.success(tActionMessages.lineItemDeleted);
      queryClient.invalidateQueries({
        queryKey: [PROJECT_BUDGET_SUMMARY_QUERY_KEY],
        refetchType: 'active',
      });
      queryClient.invalidateQueries({
        queryKey: [AVAILABLE_BUDGET_ITEMS_QUERY_KEY],
        refetchType: 'active',
      });
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.errors?.[0]?.message || error?.message || tActionMessages.errorDeletingLineItem,
      );
    },
  });
};
